export const insultReplacements: Record<string, string> = {
  idiot: "person",
  idiots: "people",
  idiotic: "misguided",
  stupid: "misguided",
  stupidity: "poor judgment",
  moron: "person",
  morons: "people",
  moronic: "poorly thought out",
  dumb: "uninformed",
  dumbass: "person",
  imbecile: "person",
  fool: "person",
  foolish: "unwise",
  fools: "people",
  incompetent: "inexperienced",
  incompetence: "lack of experience",
  lazy: "less engaged",
  useless: "not helpful",
  worthless: "not valuable",
  pathetic: "disappointing",
  loser: "person",
  losers: "people",
  jerk: "difficult person",
  jerks: "difficult people",
  clown: "person",
  clowns: "people",
  joke: "not serious",
  ridiculous: "surprising",
  absurd: "unexpected",
  insane: "surprising",
  crazy: "unexpected",
  nuts: "unusual",
  lame: "underwhelming",
  terrible: "not great",
  awful: "not ideal",
  horrible: "concerning",
  worst: "least effective",
  trash: "low quality",
  garbage: "low quality",
};
